<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            action="mailings"
    >
        <template v-slot:cell(date)="data">
            {{data.item.date | date}}
        </template>

        <template v-slot:cell(subject)="data">
            <b-badge :variant="mailingType(data.item.type).variant" class="px-2 text-uppercase">
                {{mailingType(data.item.type).label}}
            </b-badge>
            <div>{{data.item.subject}}</div>
        </template>

        <template v-slot:cell(recipient)="data">
            <div v-if="data.item.sent_to_all">
                <b-badge variant="primary" class="px-2 text-uppercase">
                    inviato a tutti
                </b-badge>
            </div>
            <div v-else>
                <div v-if="data.item.users.length === 1">
                    <div class="small text-uppercase text-primary">
                        {{data.item.users[0].surname}} {{data.item.users[0].name}}
                    </div>
                    <div class="small">{{data.item.users[0].email}}</div>
                    <div class="text-uppercase text-primary" v-if="data.item.users[0].data">
                        {{data.item.users[0].data.society}}
                    </div>
                </div>
                <div v-else>
                    {{data.item.users.length}} Destinatari
                </div>
            </div>
        </template>

    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";

    export default {
        name: "AdminMailingsTable",
        components: {InterTable},
        data() {
            return {

                fields: [
                    {key: 'recipient', label: 'Destinatario', class: 'text-left'},
                    {key: 'subject', label: 'Oggetto', class: 'text-left'},
                    {key: 'date', label: 'Data', class: 'text-center'},
                    {key: 'action', label: ''},
                ]
            }
        },
        methods: {
            mailingType: function (type) {
                switch(type) {
                    case 'change-status':
                        return {variant: 'primary', label: 'Cambio Stato'};
                    case 'new-society':
                        return {variant: 'warning', label: 'Nuova Società'};
                    case 'new-admin':
                        return {variant: 'warning', label: 'Nuovo admin'};
                    case 'reset-password':
                        return {variant: 'danger', label: 'Reset Password'};
                    case 'custom':
                        return {variant: 'secondary', label: 'Testo manuale'};
                    default:
                        return {variant: 'primary', label: type};
                }
            },
        },
    }
</script>

<style scoped>

</style>
